import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    shareOptions: [
      {
        name: '微信好友',
        icon: require('@/assets/images/detail/weChat.png'),
      },
      {
        name: '朋友圈',
        icon: require('@/assets/images/detail/circle_friend.png'),
      },
      {
        name: 'QQ好友',
        icon: require('@/assets/images/detail/qq.png'),
      },
      {
        name: '复制链接',
        icon: require('@/assets/images/detail/link.png'),
      },
    ],
  },
  mutations: {
    SET_USERINFO: (state, data) => {
      state.userInfo = data
    },
    // SET_TEACHERFLAG: (state, data) => {
    //   state.teacherFlag = data
    // },
  },
  actions: {},
  getters: {
    shareOptions: (state) => state.shareOptions,
    // hasHeadmaster: (state) => {
    //   // 判断是否存在班主任身份
    //   let teacherType = state.userInfo?.teacherType
    //   teacherType = teacherType?.split(',')
    //   return teacherType?.includes('3')
    // },
    // hasResidentTeacher: (state) => {
    //   // 判断是否存在驻校教师身份
    //   let teacherType = state.userInfo?.teacherType
    //   teacherType = teacherType?.split(',')
    //   return teacherType?.includes('2')
    // },
  },
  modules: {},
})
